import { useEffect, useState } from "react";
import { Eye, EyeOff, Loader2, Star } from "lucide-react";
import { toast } from "sonner";
import apiClient from "./api";

const FILTERS = [["all", "All"], ["visible", "Visible"], ["hidden", "Hidden"], ["low", "1–2 stars"]];

export default function AdminReviews() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("all");

  const load = () => apiClient.get("/api/admin/store/reviews", { params: filter === "visible" ? { hidden: false } : filter === "hidden" ? { hidden: true } : {} })
    .then((r) => setItems(filter === "low" ? r.data.filter((x) => x.rating <= 2) : r.data)).catch(() => toast.error("Could not load ratings"));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = async (rv) => {
    try { await apiClient.patch(`/api/admin/store/reviews/${rv.id}`, { hidden: !rv.hidden }); toast.success(rv.hidden ? "Rating is visible again" : "Rating hidden"); load(); }
    catch { toast.error("Could not update"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-reviews">
      <div>
        <p className="mb-2 text-xs uppercase tracking-[0.25em] text-[#C9BCFF]">Shop</p>
        <h1 className="font-heading text-3xl font-bold text-white md:text-4xl">Product Ratings</h1>
        <p className="mt-1 text-sm text-white/50">Ratings from verified buyers go live instantly. Hide any you don't want shown.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {FILTERS.map(([k, l]) => <button key={k} onClick={() => setFilter(k)} data-testid={`admin-reviews-filter-${k}`} className={`rounded-full border px-4 py-1.5 text-sm ${filter === k ? "border-[#FC5106] bg-[#FC5106] text-white" : "border-white/10 text-white/70 hover:text-white"}`}>{l}</button>)}
      </div>
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-[#121212]">
        {!items ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#FC5106]" /></div> : items.length === 0 ? <p data-testid="admin-reviews-empty" className="py-16 text-center text-sm text-white/50">No ratings yet.</p> : (
          <ul className="divide-y divide-white/5">
            {items.map((rv) => (
              <li key={rv.id} data-testid={`admin-review-row-${rv.id}`} className={`flex flex-wrap items-center gap-4 px-4 py-3 ${rv.hidden ? "opacity-50" : ""}`}>
                <div className="min-w-0 flex-1">
                  <p className="truncate font-semibold text-white">{rv.product_name}</p>
                  <p className="text-xs text-white/50">{rv.customer_name} · {rv.customer_email} · {new Date(rv.updated_at).toLocaleDateString("en-IN")}</p>
                </div>
                <span className="inline-flex">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`h-4 w-4 ${i <= rv.rating ? "fill-[#FC5106] text-[#FC5106]" : "text-white/15"}`} />)}</span>
                {rv.hidden && <span className="rounded-full border border-white/15 px-2 text-[10px] uppercase text-white/60">Hidden</span>}
                <button onClick={() => toggle(rv)} data-testid={`admin-review-toggle-${rv.id}`} className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 px-3 py-1.5 text-xs text-white/70 hover:text-white">
                  {rv.hidden ? <><Eye className="h-3.5 w-3.5" /> Show</> : <><EyeOff className="h-3.5 w-3.5" /> Hide</>}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
